import { render, staticRenderFns } from "./buyerDetail.vue?vue&type=template&id=29028f64&scoped=true&"
import script from "./buyerDetail.vue?vue&type=script&lang=js&"
export * from "./buyerDetail.vue?vue&type=script&lang=js&"
import style0 from "./buyerDetail.vue?vue&type=style&index=0&id=29028f64&lang=less&scoped=true&"
import style1 from "./buyerDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29028f64",
  null
  
)

export default component.exports